export interface CountryCode {
  value: string;
  label: string;
  flag?: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { value: '+1', label: 'US', flag: '🇺🇸' },
  { value: '+91', label: 'IN', flag: '🇮🇳' },
  { value: '+44', label: 'UK', flag: '🇬🇧' },
  { value: '+33', label: 'FR', flag: '🇫🇷' },
  { value: '+49', label: 'DE', flag: '🇩🇪' },
  { value: '+81', label: 'JP', flag: '🇯🇵' },
  { value: '+86', label: 'CN', flag: '🇨🇳' },
  { value: '+61', label: 'AU', flag: '🇦🇺' },
  { value: '+55', label: 'BR', flag: '🇧🇷' },
  { value: '+39', label: 'IT', flag: '🇮🇹' },
  { value: '+34', label: 'ES', flag: '🇪🇸' },
  { value: '+7', label: 'RU', flag: '🇷🇺' },
  { value: '+82', label: 'KR', flag: '🇰🇷' },
  { value: '+31', label: 'NL', flag: '🇳🇱' },
  { value: '+41', label: 'CH', flag: '🇨🇭' },
];

export const DEFAULT_COUNTRY_CODE = '+91';
